<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="vx-row w-full">
      <div class="vx-col lg:w-1/2 w-full">
        <vx-card class="flex-1" :title="$t('CourseRequest')">
          <CourseRequestMainData :CourseRequestModel="CourseRequestModel" />
        </vx-card>
        <vx-card class="flex-1" title="Invoices " v-if="CourseRequestModel.InvoiceDetails &&
          CourseRequestModel.InvoiceDetails.length > 0
          " style="margin-top: 15px">
          <vs-table ref="table" pagination :max-items="5" :data="CourseRequestModel.InvoiceDetails"
            style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{ $t('Amount') }}</vs-th>
              <vs-th>{{ $t('IsPayed') }}</vs-th>
              <vs-th>{{ $t('InvoiceAttachement') }}</vs-th>
              <vs-th v-if="CourseRequestModel.PaymentTypeID == 2">{{ $t('ConfirmPayAttachement') }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :style="{ 'background-color': tr.ColorCode }">
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Amount }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <vs-checkbox color="success" :disabled="CourseRequestModel.PaymentTypeID != 1 &&
                      CourseRequestModel.PaymentTypeID != 2
                      " v-model="tr.IsPayed"></vs-checkbox>
                  </vs-td>
                  <vs-td>
                    <a v-if="tr.Invoice.AttachmentUrl" :href="baseURL + tr.Invoice.AttachmentUrl" download
                      target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </vs-td>
                  <vs-td v-if="CourseRequestModel.PaymentTypeID == 2">
                    <a v-if="tr.ConfirmPayAttachement" :href="baseURL + tr.ConfirmPayAttachement" download
                      target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>


        <vx-card class="mt-5" :title="$t('InvitationAndDocument')"
          v-if="CourseRequestModel.StatusID == 17 || CourseRequestModel.StatusID == 15">
          <vs-table>
            <template slot="thead">
              <vs-th>{{ $t('DownloadInvitationLetter') }}</vs-th>
              <vs-th>{{ $t('DownloadPlacementLetter') }}</vs-th>
            </template>
            <vs-tr>

              <vs-td>
                <a class="mt-5" v-if="CourseRequestModel.InvitationPath"
                  :href="baseURL + CourseRequestModel.InvitationPath" download target="_blank"><feather-icon
                    icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
              </vs-td>
              <vs-td>
                <a class="mt-5" v-if="CourseRequestModel.PlacementPath" :href="baseURL + CourseRequestModel.PlacementPath"
                  download target="_blank"><feather-icon icon="DownloadIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
              </vs-td>
            </vs-tr>
          </vs-table>
        </vx-card>

      </div>

      <div class="vx-col lg:w-1/2 w-full">
        <vx-card class="flex-1" :title="$acl.check('customertrainee') ? $t('Status') : $t('StatusHistory')">
          <div v-if="!$acl.check('customertrainee')" class="vx-row">
            <div class="flex-1 ml-5">
              <p>{{ $t('Status') }}</p>
              <v-select :disabled="!CourseRequestModel.ID || $acl.check('customertrainee')
                " label="Name" class="w-full" autocomplete v-model="CourseRequestModel.StatusID" :options="Statuses"
                :reduce="(ID) => ID.ID" />
            </div>
          </div>

          <div class="vx-row mt-2">
            <vs-input class="flex-1 ml-5" :label="$t('StatusComment')" v-model="CourseRequestModel.StatusComment"
              name="StatusComment" :disabled="!CourseRequestModel.StatusID || $acl.check('customertrainee')
                " />
            <vs-button class="ml-5 mt-4" type="border" color="danger"
              @click="SendMail();
              getMailTemplate();
                                                                                                                                                                                                "
              :disabled="!CourseRequestModel.StatusID || $acl.check('customertrainee')
                ">{{$t('SendMail')}}</vs-button>
          </div>

          <vs-table ref="table" :max-items=" 5 " :data=" CourseRequestModel.StatusHistories " style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{$t('StatusName')}}</vs-th>
              <vs-th>{{$t('Comment')}}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data=" tr " :key=" indextr "
                  v-for="(              tr, indextr              ) in               data              "
                  :style=" { 'background-color': tr.ColorCode } ">
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Status.Name }}
                    </p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Comment }}
                    </p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>

        <vx-card class="flex-1" v-if=" !$acl.check('customertrainee') " :title=" $t('MailHistory') "
          style="margin-top: 15px">
          <vs-table ref="table" pagination :max-items=" 5 " :data=" CourseRequestModel.MailHistories "
            style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{$t('MailBody')}} </vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data=" tr " :key=" indextr "
                  v-for="(              tr, indextr              ) in               data              "
                  :style=" { 'background-color': tr.ColorCode } ">
                  <vs-td>
                    <p v-html="
                      tr.MailBody.length > 30
                        ? tr.MailBody.substring(0, 30)
                        : tr.MailBody
                    "></p>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                      @click=" viewMail(tr) " />
                    <a v-if=" tr.AttachmentUrl " :href=" baseURL + tr.AttachmentUrl " download
                      target="_blank"><feather-icon icon="DownloadIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>

        <vx-card class="flex-1" title="Proposal" v-if="
          CourseRequestModel.ProposalStatusHistories &&
            CourseRequestModel.ProposalStatusHistories.length > 0
        " style="margin-top: 15px">
          <vs-table ref="table" pagination :max-items=" 5 " :data=" CourseRequestModel.ProposalStatusHistories "
            style="padding-top: 15px">
            <template slot="thead">
              <vs-th>{{$t('StatusName')}}</vs-th>
              <vs-th>{{$t('Comment')}}</vs-th>
              <vs-th>{{$t('Date')}}</vs-th>
              <vs-th> {{$t('ViewPorposal')}}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data=" tr " :key=" indextr "
                  v-for="(              tr, indextr              ) in               data              "
                  :style=" { 'background-color': tr.ProposalStatus.ColorCode } ">
                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.ProposalStatus.Name }}
                    </p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.Comment }}
                    </p>
                  </vs-td>

                  <vs-td>
                    <p class="product-name font-medium truncate">
                      {{ tr.CreatedDate.split("T")[0] }}
                    </p>
                  </vs-td>

                  <vs-td>
                    <feather-icon icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                      @click=" viewProposal(tr) " />
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vx-card>

        <div v-if="
          CourseRequestModel.InvoiceDetails.length > 0 &&
            CourseRequestModel.PaymentTypeID == 2
        ">
          <vx-card :title=" $t('InvoiceAttachement') " class="mt-5" v-if="
            $acl.check('customertrainee') &&
              CourseRequestModel.InvoiceDetails &&
              !CourseRequestModel.InvoiceDetails[0].ConfirmPayAttachement
          ">
            <h6 style="color: orange">{{$t('PleaseUploadPaymentProof')}}</h6>
            <vs-upload automatic :limit=" 1 " :action=" uploadUrl " :headers=" UploadRequestHeader "
              @on-success=" successUploadPayProof " />
          </vx-card>
        </div>
      </div>
    </div>

    <vs-prompt :title=" $t('StatusMail') " accept-text="Send Mail" @accept=" SaveMail "
      :is-valid=" StatusModel.MailTemplate != undefined && !isViewMail " :active.sync=" activePrompt ">
      <VuePerfectScrollbar class="scroll-area p-4" :settings=" settings " :key=" $vs.rtl ">
        <form @submit.prevent style="max-height: 75vh; overflow-y: scroll">
          <vs-input name="mailSubject" v-if=" StatusModel.MailTemplate " :disabled=" isViewMail "
            :label-placeholder=" $t('Subject') " v-model=" StatusModel.MailTemplate.Subject " class="w-full mb-6" />

          <quill-editor :disabled=" isViewMail " v-if=" StatusModel.MailTemplate "
            v-model=" StatusModel.MailTemplate.Body " :options=" editorOption " />

          <vs-upload automatic v-if=" StatusModel.MailTemplate && !isViewMail " :limit=" 1 " :action=" uploadUrl "
            :headers=" UploadRequestHeader " @on-success=" successUpload " />

          <div class="mt-5" v-if=" isViewMail && StatusModel.MailTemplate.StatusMailAttachmnet ">
            <span>{{$t('DownloadAttachement')}}</span>
            <a :href=" baseURL + StatusModel.MailTemplate.StatusMailAttachmnet " download target="_blank"><feather-icon
                icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
          </div>
          <vs-button v-if=" StatusModel.MailTemplate " class="ml-5 mt-4" type="border" color="danger"
            @click=" ShowStatusMailPreview = !ShowStatusMailPreview ">{{ ShowStatusMailPreview ? "Hide" : "Preview"
            }}</vs-button>
          <vx-card v-if=" ShowStatusMailPreview " class="mt-5">
            <p style="max-width: 100%; margin: auto" v-html=" StatusModel.MailTemplate.Body "></p>
          </vx-card>
          <p v-if=" !StatusModel.MailTemplate ">
            {{$t('MailStatusNot')}}
          </p>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vs-prompt title="Proposal" :active.sync=" activeProposalPrompt " :is-valid=" !isViewProposal "
      @accept=" SaveProposal ">
      <VuePerfectScrollbar class="scroll-area p-4" :settings=" settings " :key=" $vs.rtl ">
        <form @submit.prevent style="height: 50vh">
          <div class="vx-col flex-1" style="padding-left: 5px" v-if=" !isViewProposal ">
            <p>{{$t('SelectProposalTemplate')}}</p>
            <v-select v-if=" !isViewProposal " label="Name" class="mb-5 w-full" autocomplete
              v-model=" ProposalModel.ProposalID " :options=" ProposalTemplates "
              @input=" selectProposal(ProposalModel.ProposalID) " :reduce=" (ID) => ID.ID " />
          </div>

          <label class="vs-input--label" v-if=" !isViewProposal ">Body</label>
          <div :key=" ProposalModel.ProposalID " v-if=" !isViewProposal ">
            <quill-editor v-model=" ProposalModel.Body " :options=" editorOption " />
          </div>
          <vs-upload v-if=" !isViewProposal " automatic :limit=" 1 " :action=" uploadUrl "
            :headers=" UploadRequestHeader " @on-success=" successUploadForProposal " />


          <vs-button class="ml-5 mt-4" type="border" color="danger" v-if=" !isViewProposal "
            @click=" ShowProposalMailPreview = !ShowProposalMailPreview ">{{ ShowProposalMailPreview ? "Hide" : "Preview"
            }}</vs-button>

          <vx-card v-if=" ShowProposalMailPreview " class="mt-5">
            <p style="max-width: 100%; margin: auto" v-html=" ProposalModel.Body "></p>
          </vx-card>


        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vx-card class="mt-5" :title=" $t('TraineeInfo') ">
      <vs-table :data=" CourseRequestModel.CourseRequestTrainees ">
        <template slot="thead">
          <vs-th sort-key="Name">{{$t('FullName')}}</vs-th>
          <vs-th sort-key="Provider">{{$t('JobTitle')}}</vs-th>
          <vs-th sort-key="Code">{{$t('IndustrySector')}}</vs-th>
          <vs-th sort-key="Code">{{$t('NameAsPassport')}}</vs-th>
          <vs-th sort-key="Code">{{$t('PassportNumber')}}</vs-th>
          <vs-th sort-key="Code">{{$t('PassportPath')}}</vs-th>
          <vs-th sort-key="Code">{{$t('VisaProof')}}</vs-th>
          <vs-th sort-key="Code">{{$t('FlightTicket')}}</vs-th>

          <vs-th sort-key="Code">{{$t('WithAccommodation')}}</vs-th>
          <vs-th sort-key="Code">RoomType</vs-th>

        </template>
        <tbody>
          <vs-tr
            v-for="(              tr, indextr              ) in               CourseRequestModel.CourseRequestTrainees              "
            :key=" indextr ">
            <vs-td>
              <vs-input v-model=" tr.TraineeName " />
            </vs-td>
            <vs-td>
              <vs-input v-model=" tr.JobTitle " />
            </vs-td>
            <vs-td>
              <v-select autocomplete label="Name" v-model=" tr.IndustrySectorID " :options=" getindustrySector "
                append-to-body :reduce=" (ID) => ID.ID " />
            </vs-td>

            <vs-td>
              <vs-input v-model=" tr.NameAsPassport " />
            </vs-td>
            <vs-td>
              <vs-input v-model=" tr.PassportNumber " />
            </vs-td>

            <vs-td>
              <a v-if=" tr.PassportPath " class="mt-5" :href=" baseURL + tr.PassportPath " download
                target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2" /></a>
            </vs-td>
            <vs-td>
              <a class="mt-5" v-if=" tr.VisaProof " :href=" baseURL + tr.VisaProof " download
                target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2" /></a>
            </vs-td>
            <vs-td>
              <a class="mt-5" v-if=" tr.FlightTicket " :href=" baseURL + tr.FlightTicket " download
                target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2" /></a>
            </vs-td>
            <vs-td>
              <vs-checkbox v-model=" tr.WithAccommodation "></vs-checkbox>
            </vs-td>

            <vs-td>
              {{tr.RoomType}}
            </vs-td>
          </vs-tr>
        </tbody>
      </vs-table>

    </vx-card>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click=" save_changes " :disabled=" !validateForm ">{{$t('Submit')}}
          </vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="danger" @click=" Cancel ">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import CourseRequestMainData from "./CourseRequestMainData.vue";
import vSelect from "vue-select";
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import moduleStatus from "@/store/settings/status/moduleStatus.js";
import Datepicker from "vuejs-datepicker";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { domain, mainSetting } from "@/gloabelConstant.js";
import moduleProposalStatus from "@/store/settings/proposalStatus/moduleProposalStatus.js";
import moduleProposalTemplate from "@/store/settings/proposalTemplate/moduleProposalTemplate.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";
import { toolbar } from "@/gloabelConstant.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";

export default {
  components: {
    vSelect,
    Datepicker,
    quillEditor,
    CourseRequestMainData,
    VuePerfectScrollbar,
  },
  data() {
    return {
      ShowProposalMailPreview: false,
      ShowStatusMailPreview: false,
      isViewProposal: false,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      baseURL: domain,
      CustomerTraineeSwitch: 2,
      selected: [],
      activePrompt: false,
      activeProposalPrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      isViewMail: false,
      otherCourse: true,
      itemsPerPage: 10,
      isMounted: false,
      CourseRequestModel: {
        ProposalRequest: {
          ProposalStatus: {
            ProposalTemplate: {},
          },
        },
        StatusHistories: [],
        MailHistories: [],
        ProposalStatusHistories: [],
        InvoiceDetails: [],
      },
      status: { Status: {} },
      listOfStatus: [],
      StatusList: [],
      oldStatus: 0,
      uploadUrl: domain + "API/Course/UploadFile",
      StatusModel: { MailTemplate: {} },
      ProposalModel: {},
      editorOption: {
        modules: {
          toolbar: toolbar,
        },
        placeholder: "Message",
      },
    };
  },

  computed: {
    getindustrySector() {
      return this.$store.state.industrySectorList.industrySectors;
    },
    validateForm() {
      var traineeNo = 0;
      var totalTrainee = 0;
      this.CourseRequestModel.CourseRequestTrainees.forEach((obj) => {
        if (obj.TraineeName != null && obj.TraineeName != "") {
          traineeNo++;
        }
      })

      debugger;
      var x = traineeNo;
      var y = this.CourseRequestModel.NoOfTrainee;

      if (this.CourseRequestModel.NoOfTrainee == null) {
        totalTrainee = 1;
      }
      else if (this.CourseRequestModel.NoOfTrainee > 0) {
        totalTrainee = this.CourseRequestModel.NoOfTrainee;
      }
      debugger
      return (
        this.CourseRequestModel.RequestStartDate != undefined &&
        (
          (this.CourseRequestModel.CustomerID > 0 &&
            this.CourseRequestModel.NoOfTrainee != undefined)
          ||
          this.CourseRequestModel.TraineeID > 0)
        &&
        (this.CourseRequestModel.CourseID > 0 ||
          this.CourseRequestModel.CourseName != undefined)
        &&
        this.CourseRequestModel.StatusID
        &&
        (traineeNo == totalTrainee)
      );
    },

    trainees() {
      return this.$store.state.traineeList.trainees;
    },
    customers() {
      return this.$store.state.customerList.customers;
    },

    Statuses() {
      debugger
      return this.$store.state.StatusList.Statuses
    },

    ProposalStatuses() {
      return this.$store.state.ProposalStatusList.ProposalStatuses;
    },
    ProposalTemplates() {
      return this.$store.state.ProposalTemplateList.ProposalTemplates;
    },
  },

  methods: {
    SaveProposal() {
      debugger;
      this.CourseRequestModel.ProposalModel = this.ProposalModel;
      this.ShowProposalMailPreview = false;
    },
    selectProposal(ID) {
      var index = this.ProposalTemplates.findIndex((e) => e.ID == ID);
      this.$set(this.ProposalModel, "Body", this.ProposalTemplates[index].Body);
    },
    SendMail() {
      debugger;
      var vm = this;
      if (
        this.StatusList.findIndex(
          (e) => e.ID == vm.CourseRequestModel.StatusID
        ) != -1 &&
        vm.CourseRequestModel.StatusID != this.oldStatus
      ) {
        this.activePrompt = true;
        this.isViewMail = false;
      }
    },
    successUploadPayProof(event) {
      debugger;
      var obj = {};
      obj.CourseRequestID = this.CourseRequestModel.ID;
      obj.ConfirmPayAttachement = event.target.responseText;
      this.$store.dispatch("courseRequestList/SavePaymentProof", obj);
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },
    initValues() {
      this.CourseRequestModel = {
        ProposalRequest: {
          ProposalStatus: {
            ProposalTemplate: {},
          },
        },
        StatusHistories: [],
        MailHistories: [],
        ProposalStatusHistories: [],
      };
    },
    Cancel() {
      this.$router.push("/CourseRequest");
    },
    getSatus() {
      this.StatusList = [];

      this.$store.state.StatusList.Statuses.forEach((element) => {
        if (element.IsRegistration != true) {
          this.StatusList.push(element);
        }
      });
    },
    viewMail(mail) {
      this.StatusModel.MailTemplate.Body = mail.MailBody;
      this.StatusModel.MailTemplate.StatusMailAttachmnet = mail.AttachmentUrl;
      this.isViewMail = true;
      this.activePrompt = true;
    },
    successUpload(event) {
      this.CourseRequestModel.StatusMailAttachmnet = event.target.responseText;
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },
    successUploadForProposal(event) {
      this.ProposalModel.DocUrl = event.target.responseText;
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: this.$t("SuccessuploadyourAttachment")
      });
    },
    getMailTemplate() {
      this.$store
        .dispatch("StatusList/GetItemByID", this.CourseRequestModel.StatusID)
        .then((res) => {
          this.StatusModel = res.data;
        });
    },
    getProposalTemplate() {
      this.$store
        .dispatch(
          "ProposalStatusList/GetItemByID",
          this.CourseRequestModel.ProposalRequest.ProposalStatusID
        )
        .then((res) => {
          this.ProposalModel = res.data.ProposalTemplate;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    },
    viewProposal(tr) {
      debugger;
      this.activeProposalPrompt = true;
      this.isViewProposal = true;
      this.ShowProposalMailPreview = true;
      this.ProposalModel = tr.ProposalRequest;
    },
    SaveMail() {
      this.listOfStatus = this.CourseRequestModel.StatusHistories;
      this.CourseRequestModel.StatusHistories = this.listOfStatus;
      this.CourseRequestModel.IsSendMail = true;
      this.ShowStatusMailPreview = false;
    },
    save_changes() {
      debugger
      if (this.CourseRequestModel.ProposalRequest.ProposalStatusID = 0 && this.CourseRequestModel.ProposalRequest != null) {
        debugger
        this.CourseRequestModel.ProposalRequest.ProposalStatusID = 1;
      }
      debugger
      this.CourseRequestModel.IsSendMail = true;
      if (this.CourseRequestModel.CourseID == 0) {
        this.CourseRequestModel.Course = null;
        this.CourseRequestModel.CourseID = undefined;
      }
      if (this.CourseRequestModel.CourseLanguageID == 0) {
        this.CourseRequestModel.Language = null;
        this.CourseRequestModel.CourseLanguageID = undefined;
      }

      if (
        this.CourseRequestModel.ID !== null &&
        this.CourseRequestModel.ID >= 0
      ) {
        this.$vs.loading();
        this.$store
          .dispatch("courseRequestList/updateItem", this.CourseRequestModel)
          .then((res) => {
            console.log(res);
            this.$vs.loading.close();
            this.$store.state.courseRequestList.search.pageNum = 1;
            this.initValues();

            this.$router.push("/CourseRequest");
          })
          .catch((error) => {
            this.$vs.loading.close();
          });
      } else {
        this.$vs.loading();
        this.CourseRequestModel.StatusID = 10;
        this.$store
          .dispatch("courseRequestList/addItem", this.CourseRequestModel)
          .then((res) => {
            console.log(res);
            this.$vs.loading.close();
            this.$store.state.courseRequestList.search.pageNum = 1;
            this.initValues();
            this.$router.push("/CourseRequest");
          })
          .catch((error) => {
            this.$vs.loading.close();
          });
      }
    },
  },

  created() {

    if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }
    if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    if (!moduleProposalTemplate.isRegistered) {
      this.$store.registerModule(
        "ProposalTemplateList",
        moduleProposalTemplate
      );
      moduleProposalTemplate.isRegistered = true;
    }
    this.$store.dispatch("ProposalTemplateList/fetchDataListItems");

    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
    this.$store.dispatch("customerList/fetchDataListItems");

    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }

    this.$store.dispatch("traineeList/fetchDataListItems");

    if (!moduleStatus.isRegistered) {
      this.$store.registerModule("StatusList", moduleStatus);
      moduleStatus.isRegistered = true;
    }



    if (!moduleProposalStatus.isRegistered) {
      this.$store.registerModule("ProposalStatusList", moduleProposalStatus);
      moduleProposalStatus.isRegistered = true;
    }
    if (this.$store.state.ProposalStatusList.ProposalStatuses.length == 0)
      this.$store.dispatch("ProposalStatusList/fetchDataListItems");
    if (this.$store.state.industrySectorList.industrySectors.length == 0)
      this.$store.dispatch("industrySectorList/fetchDataListItems");

    const ID = this.$route.params.ID;
    if (ID != undefined) {
      this.$vs.loading();
      this.$store
        .dispatch("courseRequestList/GetItemByID", ID)
        .then((res) => {
          this.$vs.loading.close();
          this.CourseRequestModel = res.data;



          this.CourseRequestModel.IsSendMail = false;
          this.CourseRequestModel.ProposalModel = {};

          if (this.$acl.check("customertrainee")) {
            this.CourseRequestModel.StatusHistories =
              this.CourseRequestModel.StatusHistories.slice(0, 1);
            this.CourseRequestModel.ProposalStatusHistories =
              this.CourseRequestModel.ProposalStatusHistories.slice(0, 1);
          }

          if (this.CourseRequestModel.ProposalRequest == null) {
            this.CourseRequestModel.ProposalRequest = {
              ProposalStatus: {
                ProposalTemplate: {},
              },
            };
            this.CourseRequestModel.ProposalRequest.ProposalStatusID = 0;
          }
          if (this.CourseRequestModel.CustomerID != null)
            this.CustomerTraineeSwitch = 2;
          else this.CustomerTraineeSwitch = 1;
          this.oldStatus = this.CourseRequestModel.StatusID;


          this.$store
            .dispatch(
              "StatusList/getNextStatusList",
              this.CourseRequestModel.StatusID
            )
            .then(() => {
              this.getSatus();
            });
        })
        .catch((err) => {
          this.$vs.loading.close();
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    } else this.CourseRequestModel.StatusID = 10;


  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style >
.con-vs-dialog .vs-dialog {
  max-width: 600px !important;
}

.vs-table--not-data {
  display: none;
}
</style>
<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }

  .con-select .vs-select {
    width: 100%;
  }
}

.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.vdp-datepicker__calendar {
  z-index: 700 !important;
}
</style>
